import {
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  clientSearchByName,
  clientGetPage,
  analyzeSingle,
  analyzeAll,
} from '@/api/peccancyrecordserv'

export default {
  state: {
    state_PeccancyRecord_SearchByNameResult: null,
    state_PeccancyRecord_GetPageResult: null,
    state_PeccancyRecord_GetDetailResult: null,
    state_PeccancyRecord_DeleteObjResult: null,
    state_PeccancyRecord_ClientSearchByNameResult: null,
    state_PeccancyRecord_ClientGetPageResult: null,
    state_PeccancyRecord_AnalyzeSingleResult: null,
    state_PeccancyRecord_AnalyzeAllResult: null,
  },
  mutations: {
    SET_PECCANCYRECORD_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PeccancyRecord_SearchByNameResult = rst;
    },
    SET_PECCANCYRECORD_GETPAGE_RESULT: (state, rst) => {
      state.state_PeccancyRecord_GetPageResult = rst;
    },
    SET_PECCANCYRECORD_GETDETAIL_RESULT: (state, rst) => {
      state.state_PeccancyRecord_GetDetailResult = rst;
    },
    SET_PECCANCYRECORD_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PeccancyRecord_DeleteObjResult = rst;
    },
    SET_PECCANCYRECORD_CLIENTSEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PeccancyRecord_ClientSearchByNameResult = rst;
    },
    SET_PECCANCYRECORD_CLIENTGETPAGE_RESULT: (state, rst) => {
      state.state_PeccancyRecord_ClientGetPageResult = rst;
    },
    SET_PECCANCYRECORD_ANALYZESINGLE_RESULT: (state, rst) => {
      state.state_PeccancyRecord_AnalyzeSingleResult = rst;
    },
    SET_PECCANCYRECORD_ANALYZEALL_RESULT: (state, rst) => {
      state.state_PeccancyRecord_AnalyzeAllResult = rst;
    },
  },
  actions: {
    PeccancyRecordServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_ClientSearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientSearchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_CLIENTSEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_CLIENTSEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_ClientGetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientGetPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_CLIENTGETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_CLIENTGETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_AnalyzeSingle({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        analyzeSingle(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_ANALYZESINGLE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_ANALYZESINGLE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PeccancyRecordServ_AnalyzeAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        analyzeAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PECCANCYRECORD_ANALYZEALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PECCANCYRECORD_ANALYZEALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_PeccancyRecord_SearchByNameResult: state => {
      return state.state_PeccancyRecord_SearchByNameResult;
    },
    get_PeccancyRecord_GetPageResult: state => {
      return state.state_PeccancyRecord_GetPageResult;
    },
    get_PeccancyRecord_GetDetailResult: state => {
      return state.state_PeccancyRecord_GetDetailResult;
    },
    get_PeccancyRecord_DeleteObjResult: state => {
      return state.state_PeccancyRecord_DeleteObjResult;
    },
    get_PeccancyRecord_ClientSearchByNameResult: state => {
      return state.state_PeccancyRecord_ClientSearchByNameResult;
    },
    get_PeccancyRecord_ClientGetPageResult: state => {
      return state.state_PeccancyRecord_ClientGetPageResult;
    },
    get_PeccancyRecord_AnalyzeSingleResult: state => {
      return state.state_PeccancyRecord_AnalyzeSingleResult;
    },
    get_PeccancyRecord_AnalyzeAllResult: state => {
      return state.state_PeccancyRecord_AnalyzeAllResult;
    },
  }
}